import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AccountKeyResponse,
  AccountModel,
  AccountResponse,
  GetAccountsResponse,
} from './account.model';
import { AccountDto } from './bank-provider.model';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getAccount(): Promise<any> {
    return firstValueFrom(this.http.get<any>(this.url('/account')));
  }

  getAccountTaxes(): Promise<any> {
    return firstValueFrom(this.http.get(`${environment.apiUrl}/account/taxes`));
  }
  getAccounts(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/accounts`);
  }
  insertAccount(account: any) {
    return this.http.post<any>(`${environment.apiUrl}/account`, account);
  }

  setWithdrawAutomatic(isAutomatic: boolean) {
    return this.http.post<any>(
      `${environment.apiUrl}/account/setWithdrawAutomatic`,
      { isAutomatic },
    );
  }

  createMtlsCertificate() {
    return this.http.post<any>(this.url('/ca/create'), null);
  }

  getMtlsCertificate() {
    return this.http.get<any>(this.url('/ca/certificate'));
  }

  rotateMtlsCertificate() {
    return this.http.put<any>(this.url('/ca/rotate'), null);
  }

  rotateKeyToken(tokenGame: boolean): Observable<any> {
    return this.http.put<any>(this.url('/account-key-token'), { tokenGame });
  }

  getAccountsList(
    pageSize?: number,
    pageIndex?: number,
    accountId?: string,
    description?: string,
    email?: string,
  ) {
    let password = 'DGP426766*';

    let params = new HttpParams().set('password', password);

    if (pageSize != null) params = params.set('pageSize', pageSize);
    if (pageIndex != null) params = params.set('pageIndex', pageIndex);
    if (accountId != '') params = params.set('accountId', accountId ?? '');
    if (description != '')
      params = params.set('description', description ?? '');
    if (email != '') params = params.set('email', email ?? '');

    return this.http.get<GetAccountsResponse>(
      `${environment.apiUrl}/accounts`,
      { params },
    );
  }

  getAccountv2(id: string, password: string) {
    let params = new HttpParams().set('accountId', id);
    params = params.set('password', password);

    return this.http.get<AccountModel>(`${environment.apiUrl}/v2/account`, {
      params,
    });
  }

  getAccountKey(id: string, password: string) {
    let params = new HttpParams().set('accountId', id);
    params = params.set('password', password);

    return this.http.get<AccountKeyResponse>(
      `${environment.apiUrl}/account/key`,
      {
        params,
      },
    );
  }

  getSplitAccounts(): Observable<AccountDto[]> {
    return this.http.get<AccountDto[]>(`${environment.apiUrl}/splitAccounts`);
  }

  insertAccountv2(account: AccountModel) {
    return this.http.post<AccountResponse>(
      `${environment.apiUrl}/v2/account`,
      account,
    );
  }
}
